// extracted by mini-css-extract-plugin
export default {"content":"CarePlanDetails_content__gDfgY"};